import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Ticket } from '../../domain/model/ticket.model';

@Injectable({ providedIn: 'root' })
export class TicketCacheService {
  private readonly _tickets$ = new BehaviorSubject<Ticket[] | null>(null);
  private readonly _lastTicket$ = new BehaviorSubject<Ticket | null>(null);

  getCurrentTickets(): Observable<Ticket[] | null> {
    return this._tickets$.asObservable();
  }
  
  getLastTicket(): Observable<Ticket | null> {
    return this._lastTicket$.asObservable();
  }

  getTicketById(id: string): Observable<Ticket | null> {
    return this._tickets$.asObservable().pipe(
      map((tickets) => tickets?.find((ticket) => ticket?.id === id) ?? null)
    );
  }

  setAll(tickets: Ticket[]): void {
    this._tickets$.next([...tickets]);
  }

  setTicket(ticket: Ticket): void {
    const current = this._tickets$.value ?? [];

    const { tickets, found } = current.reduce((accumulator, currentTicket) => {
      const isMatch = currentTicket?.id === ticket?.id;

      accumulator.found ||= isMatch;
      accumulator.tickets.push(isMatch ? ticket : currentTicket);

      return accumulator;
    }, { tickets: [] as Ticket[], found: false });

    found || tickets.push(ticket);
    this._tickets$.next(tickets);
  }

  setLastTicket(ticket: Ticket | null): void {
    this._lastTicket$.next(ticket);
  }

  clear(): void {
    this._tickets$.next(null);
    this._lastTicket$.next(null);
  }
}
